import { useState,useEffect, Fragment } from "react";


import icoArrow from '../Down_Arrow_3_.png'
import icoASC  from '../asc.png'
import icoDESC from '../desc.png'

function SortBy(props)
{

  
    const [tab, setTab] = useState({
      
        column: '',
        name: '',
        sort: '', //asc lub desc
    })

    const [dialog, setDialog] = useState(0);


    const changeDialogStatus = ()  => {

        if(dialog == 0)setDialog(1);

        if(dialog == 1)setDialog(0);

    }
    

    const goSort = (e) => {

        console.log("goSort ", e.target);

        var s_column = e.target.getAttribute("atr-col");
        var s_name   = e.target.getAttribute("atr-name");
        var s_sort   = e.target.getAttribute("atr-sort");

        setDialog(0);

        props.onChange({              
            name: s_name,  
            column: s_column,           
            sort: s_sort, //asc lub desc
        });

    }

    

    if(props.param.sort != tab.sort || props.param.column != tab.column)
    {
        if(props.param.sort == '') //nie ma ustawionego sortowania..
        {
            setTab({                
                column: '',
                name: '',
                sort: '', //asc lub desc
            });

            return;
        }

        //jest cos ustawione z listy..       

        for(var k=0; k<props.cols.length; k++)
        {
            if(props.cols[k].column == props.param.column)
            {              
                setTab({            
                    column: props.param.column,
                    name: props.cols[k].name,
                    sort: props.param.sort, //asc lub desc
                });
                break;
            }
        }
        
        
    }

    var defTitle = "Sortuj według: A-Z"
    var defImg   = <img src={icoArrow}  />

    if(tab.sort !='')
    {
        defTitle = tab.name;
    
        if(tab.sort == 'ASC')  defImg   = <img src={icoASC}  />
        if(tab.sort == 'DESC') defImg   = <img src={icoDESC}  />

    }

 

    var cssActive = "";

    var titleSort = "";

    if(tab.sort != "")
    {
        cssActive = "sort_active";
    }

    if(tab.sort == "ASC") titleSort = " (rosnąco) ";
    if(tab.sort == "DESC") titleSort = " (malejąco) ";


    return <div className={"sort_by " + cssActive}>
            <span className="sort_link" onClick={changeDialogStatus}  >{defTitle} {titleSort} {defImg} </span>

            {
                dialog == 1 &&
                <div className="sort_dialog">

               
                     <div className="sort_item"  atr-col={""}  atr-name={""}  atr-sort="" onClick={goSort}   > ustaw domyślne </div>                                                                                                                       
                        
                     {
                        props.cols.map(  (item) => {
                                return <Fragment>
                                        <div className="sort_item"  atr-col={item.column}  atr-name={item.name}  atr-sort="ASC" onClick={goSort}   ><img src={icoASC}  /> &nbsp; {item.name} (rosnąco) </div>                                        
                                        <div className="sort_item"  atr-col={item.column}  atr-name={item.name}  atr-sort="DESC"   onClick={goSort}   ><img src={icoDESC}  /> &nbsp; {item.name}  (malejąco) </div>                                        
                                </Fragment>
                        } )
                     }
                </div>
            }    

                 

    </div>
}


export default SortBy;